import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AwComponent } from '@aw/ads-components/aw-parent';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["*"];
class AwIndicatorComponent extends AwComponent {
    constructor() {
        super(...arguments);
        this.testName = 'aw-indicator';
    }
}
AwIndicatorComponent.ɵfac = function AwIndicatorComponent_Factory(t) { return ɵAwIndicatorComponent_BaseFactory(t || AwIndicatorComponent); };
AwIndicatorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwIndicatorComponent, selectors: [["aw-indicator"]], inputs: { styleClasses: "styleClasses", elementId: "elementId", textStyleClasses: "textStyleClasses", tabindex: ["data-tabindex", "tabindex"], indicatorLabel: ["data-aria-label", "indicatorLabel"], role: "role" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 4, vars: 7, consts: [["automation", "dot", 1, "dot", 3, "ngClass"], ["automation", "indicator", 1, "indicator", 3, "ngClass"]], template: function AwIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelement(1, "span", 0);
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("automation", ctx.automationValue || "indicatorComponent")("id", ctx.elementId)("tabindex", ctx.tabindex)("role", ctx.role)("aria-label", ctx.indicatorLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.styleClasses);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.textStyleClasses);
    } }, directives: [ɵngcc1.NgClass], styles: [".dot[_ngcontent-%COMP%]{border:1px solid #1a1f24;border:1px solid var(--neutral1,#1a1f24);border-radius:50%;box-sizing:content-box;display:inline-block;height:8px;margin-right:5px;padding:0;vertical-align:middle;width:8px}.indicator[_ngcontent-%COMP%]{font-size:.875rem}  .cc-button .indicator{font-weight:400;font-weight:var(--cc-button-success-font-weight,400)}  .cc-button.status-success .indicator{color:#39d627;color:var(--cc-button-status-success-c,#39d627)}  .cc-button.status-warning .indicator{color:#ba5b03;color:var(--warning,#ba5b03)}  .cc-button.status-danger .indicator{color:#d93b3d;color:var(--danger,#d93b3d)}"], changeDetection: 0 });
AwIndicatorComponent.selectorDowngrade = 'aw-indicator';
AwIndicatorComponent.propDecorators = {
    styleClasses: [{ type: Input }],
    elementId: [{ type: Input }],
    textStyleClasses: [{ type: Input }],
    tabindex: [{ type: Input, args: ['data-tabindex',] }],
    indicatorLabel: [{ type: Input, args: ['data-aria-label',] }],
    role: [{ type: Input }]
};
const ɵAwIndicatorComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AwIndicatorComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwIndicatorComponent, [{
        type: Component,
        args: [{
                selector: 'aw-indicator',
                template: "<div\n    [attr.automation]=\"automationValue || 'indicatorComponent'\"\n    [attr.id]=\"elementId\"\n    [attr.tabindex]=\"tabindex\"\n    [attr.role]=\"role\"\n    [attr.aria-label]=\"indicatorLabel\">\n    <span class=\"dot\"\n        automation=\"dot\"\n        [ngClass]=\"styleClasses\">\n    </span>\n    <span class=\"indicator\"\n        automation=\"indicator\"\n        [ngClass]=\"textStyleClasses\">\n        <ng-content></ng-content>\n    </span>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".dot{border:1px solid #1a1f24;border:1px solid var(--neutral1,#1a1f24);border-radius:50%;box-sizing:content-box;display:inline-block;height:8px;margin-right:5px;padding:0;vertical-align:middle;width:8px}.indicator{font-size:.875rem}::ng-deep .cc-button .indicator{font-weight:400;font-weight:var(--cc-button-success-font-weight,400)}::ng-deep .cc-button.status-success .indicator{color:#39d627;color:var(--cc-button-status-success-c,#39d627)}::ng-deep .cc-button.status-warning .indicator{color:#ba5b03;color:var(--warning,#ba5b03)}::ng-deep .cc-button.status-danger .indicator{color:#d93b3d;color:var(--danger,#d93b3d)}"]
            }]
    }], null, { styleClasses: [{
            type: Input
        }], elementId: [{
            type: Input
        }], textStyleClasses: [{
            type: Input
        }], tabindex: [{
            type: Input,
            args: ['data-tabindex']
        }], indicatorLabel: [{
            type: Input,
            args: ['data-aria-label']
        }], role: [{
            type: Input
        }] }); })();

class AwIndicatorModule {
}
AwIndicatorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwIndicatorModule });
AwIndicatorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwIndicatorModule_Factory(t) { return new (t || AwIndicatorModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwIndicatorModule, { declarations: function () { return [AwIndicatorComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AwIndicatorComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwIndicatorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AwIndicatorComponent
                ],
                exports: [
                    AwIndicatorComponent
                ]
            }]
    }], null, null); })();

export { AwIndicatorComponent, AwIndicatorModule };

//# sourceMappingURL=aw-ads-components-aw-indicator.js.map